module.exports = __webpack_public_path__ + "static/mobile-conferencing2-ec7fdd6847c3cc33c3ad71eb28725bc9.png";